'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dPage$0024 from "./presto.-Agent-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002441 from "./presto.-Presto-Router$$anon$41.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$40() {
  this.bj3 = null;
  this.biV = null;
  this.biW = false;
  this.bj4 = null;
  this.bj5 = false;
  this.bj8 = null;
  this.bj1 = null;
  this.bj2 = false;
  this.biX = null;
  this.biY = false;
  this.biZ = null;
  this.bj0 = false;
  this.bj6 = false;
  this.bj7 = false;
  this.bj3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bj8 = "AgentPage";
}
export { $c_Lpresto_PrestoRouter$$anon$40 as $c_Lpresto_PrestoRouter$$anon$40 };
$p = $c_Lpresto_PrestoRouter$$anon$40.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$40;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$40() {
}
export { $h_Lpresto_PrestoRouter$$anon$40 as $h_Lpresto_PrestoRouter$$anon$40 };
$h_Lpresto_PrestoRouter$$anon$40.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bj3;
});
$p.M = (function() {
  if ((!this.biW)) {
    this.biV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.biW = true;
  }
  return this.biV;
});
$p.O = (function() {
  if ((!this.bj5)) {
    this.bj4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bj5 = true;
  }
  return this.bj4;
});
$p.D = (function() {
  return this.bj8;
});
$p.t = (function() {
  if ((!this.bj2)) {
    this.bj1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bj2 = true;
  }
  return this.bj1;
});
$p.N = (function() {
  if ((!this.biY)) {
    this.biX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.biY = true;
  }
  return this.biX;
});
$p.Q = (function() {
  if ((!this.bj0)) {
    this.biZ = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002441.$c_Lpresto_PrestoRouter$$anon$41();
    this.bj0 = true;
  }
  return this.biZ;
});
$p.v = (function() {
  if ((!this.bj7)) {
    this.bj6 = false;
    this.bj7 = true;
  }
  return this.bj6;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee356) => ((p) => \u03b4scrutinee356))($j_presto$002e$002dAgent$002dPage$0024.$m_Lpresto_AgentPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$40 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$40, "presto.PrestoRouter$$anon$40", ({
  Of: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$40 as $d_Lpresto_PrestoRouter$$anon$40 };
//# sourceMappingURL=presto.-Presto-Router$$anon$40.js.map
